import { render } from "./MailTemplateDialog.vue?vue&type=template&id=0377cc00"
import script from "./MailTemplateDialog.vue?vue&type=script&lang=js"
export * from "./MailTemplateDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__